module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Sopranos-The-S2.a8d0c1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Sopranos-The-S2.jpg
// module id = xqWT
// module chunks = 0